const TECH_ICONS = {
  'Ionic React': '/icons/ionic.svg',
  Ionic: '/icons/ionic.svg',
  'Capacitor 6': '/icons/capacitor.svg',
  Capacitor: '/icons/capacitor.svg',
  Firebase: '/icons/firebase.svg',
  FCM: '/icons/firebase.svg',
  'Cloud Functions': '/icons/googlecloud.svg',
  WordPress: '/icons/wordpress.svg',
  'WordPress REST': '/icons/wordpress.svg',
  'WP-Cron': '/icons/wordpress.svg',
  TypeScript: '/icons/typescript.svg',
  PHP: '/icons/php.svg',
  'PHP 8.2': '/icons/php.svg',
  'Facebook Graph API': '/icons/facebook.svg',
  'Instagram Graph API': '/icons/instagram.svg',
  'Threads API': '/icons/threads.svg',
  SwiftUI: '/icons/swift.svg',
  PhotoKit: '/icons/apple.svg',
  'iOS 17+': '/icons/apple.svg',
  'AdMob Native': '/icons/googlecloud.svg',
  React: '/icons/react.svg',
};

export function getTechIcon(item) {
  return TECH_ICONS[item] || null;
}
